var map = {
	"./azure.png": 2874,
	"./bitbucket.png": 2528,
	"./bitbucket2.png": 4525,
	"./certificate_jira.png": 4089,
	"./certificate_pixiebrix.png": 5998,
	"./confluence.png": 2149,
	"./dean_letter.png": 262,
	"./git.png": 3449,
	"./github.png": 9776,
	"./javascript.png": 2408,
	"./jira.png": 5152,
	"./linkedin.png": 1654,
	"./masters_degree.png": 978,
	"./mysql.png": 4510,
	"./net_core.png": 2134,
	"./owasp.png": 1844,
	"./profile-picture-nb.png": 1822,
	"./python.png": 4758,
	"./sourcetree.png": 1882,
	"./studio.png": 8562,
	"./studio_code.png": 2844,
	"./vue.png": 6460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5675;